import {IOption} from "@pg-design/select-module";

import {ICalculatorValue} from "../types/ICalculatorValue";

export const getCalculatorSelectOptions = (values: ICalculatorValue, step?: number): IOption[] => {
    const lower = values.lower;
    const upper = values.upper;
    const options: number[] = [];

    if (lower && upper && step) {
        for (let i = lower; i <= upper; i += step) {
            options.push(i);
        }
    }

    return options.map((option) => ({label: `${option} lat`, value: option}));
};
import {IOption} from "@pg-design/select-module";

import {ICalculatorValue} from "../types/ICalculatorValue";

export const getCalculatorSelectOptions = (values: ICalculatorValue, step?: number): IOption[] => {
    const lower = values.lower;
    const upper = values.upper;
    const options: number[] = [];

    if (lower && upper && step) {
        for (let i = lower; i <= upper; i += step) {
            options.push(i);
        }
    }

    return options.map((option) => ({label: `${option} lat`, value: option}));
};
